import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=issuetype'],
};
